import axios from "./axios";
import { toast } from "react-toastify";

export const login = async (credentials) => {
  try {
    const response = await axios.post("/v1/users/login", credentials);
    const token = response.data.data.Token;
    localStorage.setItem("token", token);
    return response.data;
  } catch (err) {
    return err.response.data;
  }
};

export const getAllUsers = async () => {
  try {
    const response = await axios.get("/v1/users/");
    return response.data;
  } catch (err) {
    return err.response.data;
  }
};
export const getAllRoles = async () => {
  try {
    const response = await axios.get("/v1/roles/");
    return response.data;
  } catch (err) {
    return err.response.data;
  }
};

export const createUser = async (userData) => {
  try {
    const response = await axios.post("/v1/users/", {
      ...userData,
      Status: true,
    });
    return response.data;
  } catch (err) {
    return err.response.data;
  }
};
export const updateUser = async (id, userData) => {
  try {
    const response = await axios.patch(`/v1/users/${id}`, {
      ...userData,
      Status: true,
    });
    return response.data;
  } catch (err) {
    return err.response.data;
  }
};

export const deleteUser = async (id) => {
  try {
    const response = await axios.delete(`/v1/users/${id}`);
    return response.data;
  } catch (err) {
    return err.response.data;
  }
};
export const createTicket = async (ticketData) => {
  try {
    const response = await axios.post("/v1/tickets/", {
      ...ticketData,
      Status: true,
    });
    return response.data;
  } catch (err) {
    return err.response.data;
  }
};

export const getAllTickets = async (filter) => {
  try {
    const response = await axios.get(
      `/v1/tickets?FilterField=${filter.FilterField}&Value=${filter.Value}`
    );
    return response.data;
  } catch (err) {
    return err.response.data;
  }
};
export const getAllForApprovalTickets = async () => {
  try {
    const response = await axios.get(`/v1/tickets/approval/list`);
    return response.data;
  } catch (err) {
    return err.response.data;
  }
};
export const approveRejectTicket = async (ticketData) => {
  try {
    const response = await axios.post("/v1/tickets/approval/decision", {
      ...ticketData,
    });
    return response.data;
  } catch (err) {
    return err.response.data;
  }
};
